<script>
import pbiService from '@services/powerbi.js'
import * as pbi from 'powerbi-client'
import store from '@state/store'

export default {
  inheritAttrs: false,
  props: {
    workspaceId: {
      type: String,
      default: '',
    },
    reportId: {
      type: Array,
      required: true,
    },
  },
  computed: {
    embedInfo() {
      //  return this.$store.getters['users/embedInfo']
      if (store.getters['users/embedInfo']) {
        return store.getters['users/embedInfo']
      } else {
        var embedInfo = JSON.parse(localStorage.getItem('embed_info'))
        return {
          token: embedInfo.embedToken.token,
          embedReports: embedInfo.embedReport,
          expiration: embedInfo.embedToken.expiration,
        }
      }
    },
  },
  created() {
    this.getPBIReports()
  },
  methods: {
    async getPBIReports() {
      var reportConfig = await pbiService.getReportConfig(
        this.embedInfo,
        this.reportId
      )
      reportConfig.settings.panes = { filters: { visible: false } }
      // reportConfig.pageView = 'fitToWidth'
      const powerbi = new pbi.service.Service(
        pbi.factories.hpmFactory,
        pbi.factories.wpmpFactory,
        pbi.factories.routerFactory
      )
      var reportContainer = document.getElementById('container')
      var report = powerbi.embed(reportContainer, reportConfig)
      report.off('loaded')
      report.off('rendered')
      report.on('error', function () {
        report.off('error')
      })
    },
  },
}
</script>

<template>
  <section id="report">
    <div id="container" style="height: 90vh"></div>
  </section>
</template>
